import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux'

// actions
import {search} from "../../../redux/actions/hotel/afiPickupScheduleActions";
import {setFilter, setItem} from "../../../redux/actions/generalActions/subFormActions";

// labels
import {NO_DATA_FOUND} from "../../../components/i18n/i18n";
import {getStateByPath} from "../../../redux/selectors";
import TimeIndicator from "../../../components/schedules/timeIndicator";

const AfiPickupScheduleList = props => {
    const componentState = useSelector(state => getStateByPath(state, props?.path));
    const {domainObject: afi, app, udn} = componentState?.data;
    const fbDataBaseId = app?.fbDataBase?.id
    const {listChildObjects} = props.subFormProps

    const [items, setItems] = useState()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (udn?.id === undefined || afi?.id === undefined)
            return

        const _filter = {
            fbDataBase: {id: fbDataBaseId},
            item: {
                udnFrom: {id: udn.id},
                afi: {id: afi.id}
            }
        };

        props.setFilter(_filter);
        refreshDataList(_filter);
    }, []);


    // procesamiento de las entradas
    useEffect(() => {
        if (!listChildObjects || listChildObjects.length == 0) {
            setItems(null)
            return
        }

        let map = {} // mapa con las entradas listas para mostrar
        const childOrdered = Object.values(listChildObjects).sort((a, b) => (a?.day > b?.day) ? 1 : -1); // ordenar las entradas por día de la semana
        const dayNames = [...new Set(Object.values(childOrdered).map(item => item['dayName']))];  // obtener los días de la semana

        // recopilar los horarios de cada día
        dayNames.forEach(name => {

            // filtrar las entradas correspondientes al día de la lista
            const hours = Object.values(childOrdered).filter(hour => {
                if (hour['dayName'] !== name)
                    return

                return {
                    id: hour?.id,
                    time24: hour?.time24
                }
            })

            // ordenar las entradas por horario
            const sortedHours = Object.values(hours).sort((a, b) => {
                const actualDate = new Date().toISOString().split("T")[0]
                const timeA = new Date(`${actualDate}T${a?.time24}`);
                const timeB = new Date(`${actualDate}T${b?.time24}`);
                return timeA - timeB;
            });

            map = {...map, [name]: sortedHours} // agregar la entrada procesada al objeto de salida
        })

        setItems(map)
    }, [listChildObjects])

    const changeLoading = value => setLoading(value)

    const refreshDataList = (_filter) => {
        setLoading(true)
        props.search(0, 1000, _filter, changeLoading)
    }

    if(loading)
        return <center>
            <i className={'fa fa-spinner fa-spin fa-2x fa-fw'}/>
        </center>

    if (items == null)
        return <center>{NO_DATA_FOUND}</center>

    return <div className={'selected-hours-container'}>
        {
            Object.keys(items).map(key => {
                const hours = items[key]

                return <div key={`item-${key}`}>
                    <div>{key}</div>
                    {
                        hours.map((value, i) => {
                            const isRecurring = value?.recurring
                            const time = isRecurring
                                ? value?.recurringSchedule?.label
                                : value?.time24


                            return <TimeIndicator
                                key={`item-${i}`}
                                clazz={isRecurring ? 'selected-hour-container-recurring' : 'selected-hour-container'}
                                time={time}
                                id={value?.id}
                                fbDataBaseId={fbDataBaseId}
                            />
                        })
                    }
                </div>
            })
        }
    </div>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    formProps : state.formProps,
    subFormProps : state.subFormProps,
})

const mapActionsToProps = ({
    setItem,
    setFilter,
    search,
})

export default connect(mapStateToProps, mapActionsToProps)(AfiPickupScheduleList)